import Navigation from "../components/Navigation"
import { Link } from "react-router-dom"
import "./MenuPage.scss"

const MenuPage = () => {
  return (
    <div className="menu-page">
      <Navigation />

      {/* Hero Section */}
      <section className="menu-hero">
        <div className="container">
          <h1 className="hero-title">Our Menu</h1>
          <p className="hero-description">
            Discover our signature cakoi and pau, made fresh daily with authentic recipes and premium ingredients that
            bring out the best flavors of Malaysian street food.
          </p>
        </div>
      </section>

      {/* Menu Items */}
      <section className="menu-items">
        <div className="container">
          <div className="menu-grid">
            {/* Cakoi */}
            <div className="card menu-card">
              <div className="card-header">
                <div className="menu-image">
                  <img
                    src="https://via.placeholder.com/400x300/CB0101/FFFFFF?text=Golden+Cakoi"
                    alt="Golden crispy cakoi with dipping sauce"
                  />
                  <span className="badge badge-primary">Bestseller</span>
                </div>
                <h3 className="menu-title">Cakoi (6 pieces)</h3>
                <div className="menu-price">RM 5.00</div>
                <p className="menu-description">
                  Six pieces of golden, crispy cakoi served with one delicious dipping sauce
                </p>
              </div>
              <div className="card-content">
                <div className="menu-details">
                  <div className="details-section">
                    <h4>What's Included:</h4>
                    <ul>
                      <li>• 6 freshly fried cakoi</li>
                      <li>• 1 signature dipping sauce</li>
                      <li>• Served hot and crispy</li>
                    </ul>
                  </div>

                  <div className="menu-features">
                    <div className="feature">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                        <polyline points="12,6 12,12 16,14" stroke="currentColor" strokeWidth="2" />
                      </svg>
                      <span>Fresh Daily</span>
                    </div>
                    <div className="feature">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <polygon
                          points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"
                          stroke="currentColor"
                          strokeWidth="2"
                        />
                      </svg>
                      <span>Authentic</span>
                    </div>
                    <div className="feature">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" />
                        <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
                        <path
                          d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                          stroke="currentColor"
                          strokeWidth="2"
                        />
                      </svg>
                      <span>Perfect Share</span>
                    </div>
                  </div>

                  <div className="menu-description-full">
                    <h4>Description:</h4>
                    <p>
                      Our signature cakoi are hand-twisted and fried to golden perfection. Each piece is crispy on the
                      outside, soft and chewy on the inside, with a delightful texture that pairs perfectly with our
                      specially crafted dipping sauce.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Pau */}
            <div className="card menu-card">
              <div className="card-header">
                <div className="menu-image">
                  <img
                    src="https://via.placeholder.com/400x300/CB0101/FFFFFF?text=Steamed+Pau"
                    alt="Steamed pau with various fillings"
                  />
                  <span className="badge badge-red">3 Flavors</span>
                </div>
                <h3 className="menu-title">Pau (Each)</h3>
                <div className="menu-price">RM 6.00</div>
                <p className="menu-description">Soft, fluffy steamed pau available in three delicious flavors</p>
              </div>
              <div className="card-content">
                <div className="menu-details">
                  <div className="details-section">
                    <h4>Available Flavors:</h4>
                    <div className="flavors-list">
                      <div className="flavor-item">
                        <div className="flavor-dot chocolate"></div>
                        <span className="flavor-name">Chocolate</span>
                        <span className="flavor-desc">Rich & Sweet</span>
                      </div>
                      <div className="flavor-item">
                        <div className="flavor-dot sambal"></div>
                        <span className="flavor-name">Sambal</span>
                        <span className="flavor-desc">Spicy & Savory</span>
                      </div>
                      <div className="flavor-item">
                        <div className="flavor-dot red-bean"></div>
                        <span className="flavor-name">Kacang Merah</span>
                        <span className="flavor-desc">Sweet Red Bean</span>
                      </div>
                    </div>
                  </div>

                  <div className="menu-features">
                    <div className="feature">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                        <polyline points="12,6 12,12 16,14" stroke="currentColor" strokeWidth="2" />
                      </svg>
                      <span>Steamed Fresh</span>
                    </div>
                    <div className="feature">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <polygon
                          points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"
                          stroke="currentColor"
                          strokeWidth="2"
                        />
                      </svg>
                      <span>Premium Fill</span>
                    </div>
                    <div className="feature">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" />
                        <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
                        <path
                          d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                          stroke="currentColor"
                          strokeWidth="2"
                        />
                      </svg>
                      <span>All Ages</span>
                    </div>
                  </div>

                  <div className="menu-description-full">
                    <h4>Description:</h4>
                    <p>
                      Our pau are steamed to perfection with soft, fluffy dough that melts in your mouth. Each pau is
                      generously filled with premium ingredients - from rich chocolate to spicy sambal and sweet red
                      bean paste.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Special Offers */}
          <div className="special-offers">
            <h2 className="section-title">Special Offers</h2>
            <div className="offers-grid">
              <div className="card offer-card family-pack">
                <h3>Family Pack</h3>
                <p>12 Cakoi + 4 Pau (Mix flavors) + 2 Dipping Sauces</p>
                <div className="offer-pricing">
                  <span className="offer-price">RM 28.00</span>
                  <span className="original-price">RM 34.00</span>
                  <span className="badge badge-red">Save RM 6</span>
                </div>
              </div>

              <div className="card offer-card student-special">
                <h3>Student Special</h3>
                <p>3 Cakoi + 1 Pau (Any flavor) + 1 Dipping Sauce</p>
                <div className="offer-pricing">
                  <span className="offer-price">RM 8.50</span>
                  <span className="badge badge-blue">Student ID Required</span>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="menu-cta">
            <div className="cta-content">
              <h3>Ready to Order?</h3>
              <p>Visit any of our partner locations or contact us to find the nearest Cakoi's outlet</p>
              <div className="cta-buttons">
                <a href="/#contact" className="btn btn-white btn-lg">
                  Find Locations
                </a>
                <Link to="/partner" className="btn btn-outline btn-lg">
                  Become a Partner
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-section">
              <h3 className="footer-title">Cakoi's</h3>
              <p className="footer-text">Authentic Malaysian cakoi and pau, made fresh daily with love.</p>
            </div>
            <div className="footer-section">
              <h4 className="footer-heading">Menu</h4>
              <ul className="footer-links">
                <li>
                  <a href="#">Cakoi</a>
                </li>
                <li>
                  <a href="#">Pau</a>
                </li>
                <li>
                  <a href="#">Special Offers</a>
                </li>
                <li>
                  <a href="#">Catering</a>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h4 className="footer-heading">Quick Links</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/menu">Menu</Link>
                </li>
                <li>
                  <Link to="/partner">Become a Partner</Link>
                </li>
                <li>
                  <a href="/#contact">Contact</a>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h4 className="footer-heading">Connect</h4>
              <ul className="footer-links">
                <li>
                  <a href="#">Facebook</a>
                </li>
                <li>
                  <a href="#">Instagram</a>
                </li>
                <li>
                  <a href="#">WhatsApp</a>
                </li>
                <li>
                  <a href="#">Order Online</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 Cakoi's. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default MenuPage
